import { IDynamicKeyValue, INameId } from '@modeso/types__aumico-lib-core-be';

export interface ITemplatesSubtotalFormResult {
    name: string;
    description: IDynamicKeyValue;
    scope: INameId;
    positionBeforeSubtotal: INameId;
    positionBeforeSubtotalIndex?: number;
}
